module.exports = __webpack_public_path__ + "img/full_logo-white.f142f00f.png";